import { Api } from 'utils';

class MissionService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/missions',params),
		create: async (params?: any) => Api.createResponse('admin/missions/create',params),
		update: async (params?: any) => Api.createResponse('admin/missions/update',params),
		delete: async (params?: any) => Api.createResponse('admin/missions/delete',params),
	}

}

export default MissionService;